// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lL5W","col":"styles_col__1cGmo","actions":"styles_actions__2SWE7","conflict":"styles_conflict__2Y9Pi"};